import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useCredentials = (supplierUid) => {
    return useQuery({
        queryKey: ['credentials', supplierUid],
        queryFn: () => api.getCredentialsBySupplier(supplierUid),
        enabled: !!supplierUid,
    });
};

export const useCredential = (uid, options = {}) => {
    return useQuery({
        queryKey: ['credentials', 'detail', uid],
        queryFn: () => api.getCredential(uid),
        enabled: !!uid && (options.enabled !== false),
        ...options,
    });
};

export const useCreateCredential = (supplierUid) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => api.createCredential(supplierUid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['credentials', supplierUid] });
        },
    });
};

export const useUpdateCredential = (supplierUid) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid, data }) => api.updateCredential(uid, data),
        onSuccess: (_, { uid }) => {
            queryClient.invalidateQueries({ queryKey: ['credentials', supplierUid] });
            queryClient.invalidateQueries({ queryKey: ['credentials', 'detail', uid] });
        },
    });
};

export const useDeleteCredential = (supplierUid) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (uid) => api.deleteCredential(uid),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['credentials', supplierUid] });
        },
    });
};
